import { formatCurrency, formatRelative } from '../../utils/format'

export interface Stats {
  order_count: number
  open_orders: number
  total_amount: number
  avg_order_value: number
  reorder_cadence_days: number | null
  first_order_date: string | null
  last_order_date: string | null
  days_since_last_order: number | null
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between py-1.5 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium text-foreground tabular-nums">{value}</span>
    </div>
  )
}

export default function RelationshipCard({ stats, source }: { stats: Stats; source: string | undefined }) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <h3 className="text-sm font-semibold text-foreground mb-2">Relationship</h3>
      <div className="divide-y divide-border">
        <Row label="Lifetime orders" value={String(stats.order_count)} />
        <Row label="Order volume" value={formatCurrency(stats.total_amount)} />
        <Row label="Open orders" value={String(stats.open_orders)} />
        <Row label="Avg order value" value={formatCurrency(stats.avg_order_value)} />
        <Row
          label="Reorder cadence"
          value={stats.reorder_cadence_days === null ? '—' : `Every ${stats.reorder_cadence_days} days`}
        />
        <Row label="First order" value={formatRelative(stats.first_order_date)} />
        <Row label="Last order" value={formatRelative(stats.last_order_date)} />
        {source ? <Row label="Delivery" value={source.replace('_', ' ')} /> : null}
      </div>
    </div>
  )
}
